import styled from 'styled-components';

export default styled.div`
  position: absolute;
  width: 100%;
  top: 4.5rem;
  ${props => props.thisStyles}
`;
